import { useCallback } from 'react'
import { Contract } from 'web3-eth-contract'

import { stake, getAliceAddress } from '../../sushi/utils'
import useYam from './useYam'
// import { getFullDisplayBalance } from '../../utils/bakery/formatBalance'

// hooks
import { useActiveWeb3React } from '../'
import { BigNumber } from '../../sushi'

const useStake = (lpTokenAddress: string, masterContract: Contract) => {
  const {account} = useActiveWeb3React()
  const sushi = useYam()
  
  const handleStake = useCallback(
    async (amount: string) => {
      const AliceAddress = await getAliceAddress(sushi)
      if (lpTokenAddress === AliceAddress) {
        amount = new BigNumber(amount).times(new BigNumber(10).pow(6)).dividedBy(new BigNumber(10).pow(18)).toFixed().toString()
      }
      const txHash = await stake(
        masterContract,
        lpTokenAddress,
        amount,
        account,
      )
      console.log(txHash)
    },
    [account, lpTokenAddress, masterContract, sushi],
  )

  return { onStake: handleStake }
}

export default useStake
